import {
    GET_CATEGORIES,
    IS_LOADING,
  } from './submitURLActionsTypes';
  
  const INITIAL_STATE = {
    categoryLists: [],
    isLoading: false,
  };
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case GET_CATEGORIES:
        return {
          ...state,
          categoryLists: action.payload,
        };
        case IS_LOADING:
          return {
            ...state,
            isLoading: action.payload,
          };
      default:
        return state;
    }
  };
  